import Vue from 'vue';

const state = {};

const mutations = {};

const actions = {
  async fetchDenunciationsInformations({ dispatch }) {
    const { data, status } = await Vue.axios.get('/denuntiation_information');
    if (status != 200) {
      await dispatch('generateSnackBarMessage', {
        message: 'Ocurrió un error al obtener los datos',
        type: 'error',
      });
    }
    return { data, status };
  },
  async updateDenunciationsInformations({ dispatch }, denunciationsInformations) {
    const formData = new FormData();
    formData.append('title', denunciationsInformations.title);
    formData.append('content', denunciationsInformations.content);
    if (denunciationsInformations.file) {
      formData.append('file', denunciationsInformations.file);
    }
    if (denunciationsInformations.file_formulario) {
      formData.append('file_formulario', denunciationsInformations.file_formulario);
    }
    formData.append('title_formulario', denunciationsInformations.title_formulario);
    formData.append('text_formulario', denunciationsInformations.text_formulario);
    formData.append('url_formulario', denunciationsInformations.url_formulario);
    if (denunciationsInformations.file_cell) {
      formData.append('file_cell', denunciationsInformations.file_cell);
    }
    formData.append('title_cell', denunciationsInformations.title_cell);
    formData.append('text_cell', denunciationsInformations.text_cell);
    if (denunciationsInformations.file_email) {
      formData.append('file_email', denunciationsInformations.file_email);
    }
    formData.append('title_email', denunciationsInformations.title_email);
    formData.append('text_email', denunciationsInformations.text_email);
    const { data, status } = await Vue.axios.post(
      `/denuntiation_information/${denunciationsInformations.id}`,
      formData
    );
    if (status != 200 && status != 201 && status != 204) {
      await dispatch('createResponseMessage', {
        message: data.message ||
          'Ocurrió un error actualizando los datos',
        type: 'error',
      });
    } else {
      await dispatch('generateSnackBarMessage', {
        message: data.message || 'Se guardó correctamente',
        type: 'success',
      });
    }
    return { data, status };
  },
};

export default { state, mutations, actions };
